(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meshkat-product-bundles"] && !Shopify.designMode) return;
  try {
    
function resetMeshkatBundleForm(form){
  delete form.dataset.mkpSubmitting;
  form.removeAttribute('aria-busy');
  const button=form.querySelector('button[type="submit"]');
  if(!button||!button.dataset.mkpOriginalLabel)return;
  button.disabled=false;
  button.textContent=button.dataset.mkpOriginalLabel;
  delete button.dataset.mkpOriginalLabel;
}

document.addEventListener('submit',async function(event){
  const form=event.target.closest('.mkp-product-form');
  if(!form)return;
  event.preventDefault();
  if(form.dataset.mkpSubmitting==='true')return;
  form.dataset.mkpSubmitting='true';
  form.setAttribute('aria-busy','true');
  const button=form.querySelector('button[type="submit"]');
  if(button){
    button.dataset.mkpOriginalLabel=button.textContent.trim();
    button.textContent='Adding…';
    button.disabled=true;
  }
  try{
    const root=window.Shopify?.routes?.root||'/';
    const response=await fetch(root+'cart/add.js',{
      method:'POST',
      headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
      body:new FormData(form)
    });
    if(!response.ok)throw new Error('Cart request failed');
    await response.json();
    await new Promise(resolve=>window.setTimeout(resolve,300));
    window.location.assign(root+'cart');
  }catch(error){
    resetMeshkatBundleForm(form);
    HTMLFormElement.prototype.submit.call(form);
  }
});

window.addEventListener('pageshow',function(){
  document.querySelectorAll('.mkp-product-form[data-mkp-submitting="true"]').forEach(resetMeshkatBundleForm);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meshkat-product-hero"] && !Shopify.designMode) return;
  try {
    
function activateMeshkatMedia(gallery,targetIndex,direction){
  const items=Array.from(gallery.querySelectorAll('[data-mkp-media]'));
  if(!items.length)return;
  const requested=Number(targetIndex);
  const normalized=((requested%items.length)+items.length)%items.length;
  const previous=Number(gallery.dataset.mkpCurrent||0);
  const movement=direction||(normalized>=previous?'next':'previous');
  gallery.dataset.mkpDirection=movement;
  gallery.dataset.mkpCurrent=String(normalized);

  items.forEach(function(item){
    const isActive=item.dataset.mkpMedia===String(normalized);
    item.hidden=!isActive;
    item.classList.toggle('is-active',isActive);
    item.setAttribute('aria-hidden',isActive?'false':'true');
    const video=item.querySelector('video');
    if(!video)return;
    if(isActive){
      video.muted=true;
      const playback=video.play();
      if(playback&&typeof playback.catch==='function')playback.catch(function(){});
    }else{
      video.pause();
    }
  });
  let activeThumb=null;
  gallery.querySelectorAll('[data-mkp-target]').forEach(function(button){
    const isActive=button.dataset.mkpTarget===String(normalized);
    button.classList.toggle('is-active',isActive);
    button.setAttribute('aria-pressed',isActive?'true':'false');
    if(isActive)activeThumb=button;
  });
  if(gallery.dataset.mkpReady==='true'&&activeThumb){
    activeThumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  }
  const status=gallery.querySelector('[data-mkp-status]');
  if(status)status.textContent='Gallery item '+(normalized+1)+' of '+items.length;
  gallery.dataset.mkpReady='true';
}

function moveMeshkatMedia(gallery,step){
  const current=Number(gallery.dataset.mkpCurrent||0);
  activateMeshkatMedia(gallery,current+step,step>0?'next':'previous');
}

function largestMeshkatImageSource(image){
  const srcset=image.getAttribute('srcset');
  if(!srcset)return image.currentSrc||image.src;
  const candidates=srcset.split(',').map(function(candidate){
    const parts=candidate.trim().split(/\s+/);
    return {src:parts[0],width:parseInt(parts[1],10)||0};
  }).sort(function(a,b){return b.width-a.width;});
  return candidates[0].src||image.currentSrc||image.src;
}

function openMeshkatLightbox(image){
  const gallery=image.closest('[data-mkp-gallery]');
  const lightbox=gallery&&gallery.querySelector('[data-mkp-lightbox]');
  const expanded=lightbox&&lightbox.querySelector('[data-mkp-lightbox-image]');
  if(!lightbox||!expanded)return;
  expanded.src=largestMeshkatImageSource(image);
  expanded.alt=image.alt||'Expanded product image';
  lightbox.hidden=false;
  gallery._mkpZoomOpener=image;
  document.body.classList.add('mkp-lightbox-open');
  lightbox.querySelector('[data-mkp-lightbox-close]').focus();
}

function closeMeshkatLightbox(lightbox){
  if(!lightbox)return;
  const gallery=lightbox.closest('[data-mkp-gallery]');
  const expanded=lightbox.querySelector('[data-mkp-lightbox-image]');
  lightbox.hidden=true;
  if(expanded)expanded.removeAttribute('src');
  document.body.classList.remove('mkp-lightbox-open');
  if(gallery){
    const main=gallery.querySelector('.mkp-gallery__main');
    if(main)main.focus();
  }
}

function setupMeshkatGallery(gallery){
  if(!gallery||gallery.dataset.mkpInitialized==='true')return;
  gallery.dataset.mkpInitialized='true';
  activateMeshkatMedia(gallery,0,'next');
  const main=gallery.querySelector('.mkp-gallery__main');
  if(!main||gallery.dataset.mkpSwipe!=='true')return;
  let startX=0;
  let startY=0;
  let activePointer=null;
  main.addEventListener('pointerdown',function(event){
    if(!event.isPrimary||event.button!==0)return;
    activePointer=event.pointerId;
    startX=event.clientX;
    startY=event.clientY;
  });
  main.addEventListener('pointerup',function(event){
    if(event.pointerId!==activePointer)return;
    activePointer=null;
    const distanceX=event.clientX-startX;
    const distanceY=event.clientY-startY;
    if(Math.abs(distanceX)<45||Math.abs(distanceX)<=Math.abs(distanceY))return;
    gallery.dataset.mkpIgnoreClick='true';
    moveMeshkatMedia(gallery,distanceX<0?1:-1);
    window.setTimeout(function(){delete gallery.dataset.mkpIgnoreClick;},0);
  });
  main.addEventListener('pointercancel',function(){
    activePointer=null;
  });
}

document.querySelectorAll('[data-mkp-gallery]').forEach(setupMeshkatGallery);
document.addEventListener('click',function(event){
  const closeButton=event.target.closest('[data-mkp-lightbox-close]');
  if(closeButton){
    closeMeshkatLightbox(closeButton.closest('[data-mkp-lightbox]'));
    return;
  }
  const lightbox=event.target.closest('[data-mkp-lightbox]');
  if(lightbox&&event.target===lightbox){
    closeMeshkatLightbox(lightbox);
    return;
  }
  const zoomImage=event.target.closest('[data-mkp-gallery][data-mkp-zoom="true"] .mkp-gallery__item.is-active img');
  if(zoomImage){
    const gallery=zoomImage.closest('[data-mkp-gallery]');
    if(gallery.dataset.mkpIgnoreClick!=='true')openMeshkatLightbox(zoomImage);
    return;
  }
  const thumb=event.target.closest('[data-mkp-gallery] [data-mkp-target]');
  if(!thumb)return;
  const gallery=thumb.closest('[data-mkp-gallery]');
  const current=Number(gallery.dataset.mkpCurrent||0);
  const target=Number(thumb.dataset.mkpTarget);
  activateMeshkatMedia(gallery,target,target>=current?'next':'previous');
});
document.addEventListener('keydown',function(event){
  const openLightbox=document.querySelector('[data-mkp-lightbox]:not([hidden])');
  if(openLightbox){
    if(event.key==='Escape'){
      event.preventDefault();
      closeMeshkatLightbox(openLightbox);
    }else if(event.key==='Tab'){
      event.preventDefault();
      openLightbox.querySelector('[data-mkp-lightbox-close]').focus();
    }
    return;
  }
  const main=event.target.closest('[data-mkp-gallery] .mkp-gallery__main');
  if(!main)return;
  const gallery=main.closest('[data-mkp-gallery]');
  if((event.key==='Enter'||event.key===' ')&&gallery.dataset.mkpZoom==='true'){
    const activeImage=gallery.querySelector('.mkp-gallery__item.is-active img');
    if(activeImage){
      event.preventDefault();
      openMeshkatLightbox(activeImage);
    }
  }else if(event.key==='ArrowLeft'){
    event.preventDefault();
    moveMeshkatMedia(gallery,-1);
  }else if(event.key==='ArrowRight'){
    event.preventDefault();
    moveMeshkatMedia(gallery,1);
  }
});
document.addEventListener('shopify:block:select',function(event){
  const section=event.target.closest('.shopify-section')||event.target;
  const blockId=event.detail&&event.detail.blockId;
  if(!blockId)return;
  const media=section.querySelector('[data-mkp-media][data-mkp-block-id="'+CSS.escape(blockId)+'"]');
  if(media)activateMeshkatMedia(media.closest('[data-mkp-gallery]'),media.dataset.mkpMedia);
});
document.addEventListener('shopify:section:load',function(event){
  event.target.querySelectorAll('[data-mkp-gallery]').forEach(setupMeshkatGallery);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meshkat-product-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('[data-mk-gallery] [data-image-src]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-mk-gallery]');
    const mainImage = gallery.querySelector('.mk-gallery__main img');
    if (!mainImage) return;
    mainImage.src = thumb.dataset.imageSrc;
    mainImage.removeAttribute('srcset');
    gallery.querySelectorAll('[data-image-src]').forEach((item) => item.classList.toggle('is-active', item === thumb));
  });

  } catch(e) { console.error(e); }
})();
})();
